/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
import axios from 'axios'
import moment from 'moment'

export default {
  data () {
    return {
      allSources: {
        WEBSITE: {
          label: 'Organic',
          color: '#1d7299'
        },
        LANDING_PAGE_EMAIL_INVITE: {
          label: 'Landing page',
          color: '#f30075'
        },
        IN_MAIL_EMAIL_INVITE: {
          label: 'In-mail',
          color: '#6a4ee4'
        },
        PORTAL_COPY_LINK_INVITE: {
          label: 'Share link',
          color: '#fbb800'
        },
        SMS_INVITE: {
          label: 'SMS',
          color: '#82cced'
        },
        QR_CODE: {
          label: 'QR code',
          color: '#d3d3d3'
        },
        FACEBOOK_TAB: {
          label: 'Facebook tab',
          color: '#ff89c2'
        },
        EMBEDDED_REVIEW_WIDGET: {
          label: 'Embedded review form',
          color: '#a698e3'
        },
        REVIEW_TAB_WIDGET_INVITE: {
          label: 'Other onsite widgets',
          color: '#ffe6a0'
        },
        WHATSAPP: {
          label: 'WhatsApp Organic',
          color: '#79DEBE'
        },
        WHATSAPP_INVITE: {
          label: 'WhatsApp Invite',
          color: '#24B889'
        }
      },
      filterList: [
        {
          name: 'Last 7 days',
          value: '7_days'
        },
        {
          name: 'Previous month',
          value: 'previous_month'
        },
        {
          name: 'Last 6 months',
          value: 'previous_6_months'
        },
        {
          name: 'Last 12 months',
          value: 'last_12_months'
        }
      ],
      screenWidth: window.innerWidth,
      isFreeSubscriptionActive: false,
      userInfo: JSON.parse(localStorage.getItem('billingDetails')),
      businessSlug: localStorage.getItem('org_slug'),
      businessId: localStorage.getItem('org_id'),
      cfUrl: process.env.HP_APP_URL,
      growthCategory: ['Lite', 'Lite (Monthly)', 'G1 Annual', 'G2 Annual', 'G3 Annual', 'G4 Annual', 'G1 Monthly', 'G2 Monthly', 'G3 Monthly', 'G4 Monthly', 'G1', 'G2', 'G3', 'G4'],
      proCategory: ['P1', 'P2', 'P3', 'P4', 'Pro', 'Enterprise', 'P1 Annual', 'P2 Annual', 'P3 Annual']
    }
  },
  methods: {
    randUnique () {
      let s = Date.now() + Math.random()
      return s.toString().replace('.', '.')
    },
    /**
     *  Redirect to renew or upgrade page
     *  @returns {void}
     */
    redirectToRenewOrUpgrade () {
      this.$router.push('/billing/edit-plan/g1/monthly')
    },
    /**
     * Calculate completion percentage of progress bar
     *
     * @param {number} val Current completion value
     * @param {number} total Total value
     *
     * @return {number}
     */
    calcProgressPercent (val, total) {
      return Math.round((val / total) * 100) || 0
    },
    getStarRatingInteger (ratingString) {
      return Math.floor(parseFloat(ratingString))
    },
    generateUniqueString () {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    },
    generateRandomInt (min = 0, max = 1) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    getCurrentMySQLDate () {
      return moment().format('YYYY-MM-DD')
    },
    /**
     * Process start and end dates based on selected filter
     *
     * @param {object} qs The qs component instance for query string composition
     * @param {object} moment The date & time comoponent instance
     * @param {string} filter The selected drop down filter option
     * @param {boolean} reverse Whether or not to reverse the values - some endpoints are using start and
     *                          end dates incorrectly and so swapping them gets the desired results
     *
     * @returns {string}
     */
    dateFilters (qs, moment, filter, reverse = false) {
      let endDate = moment()
      let startDate = moment()

      switch (filter) {
        case '7_days':
          endDate.subtract(1, 'day')
          startDate.subtract(7, 'days')
          break
        case 'previous_month':
          endDate.subtract(1, 'month')
          endDate.endOf('month')
          startDate.subtract(1, 'month')
          startDate.startOf('month')
          break
        case 'previous_6_months':
          endDate.subtract(1, 'month')
          endDate.endOf('month')
          startDate.subtract(6, 'months')
          startDate.startOf('month')
          break
        case 'last_12_months':
          endDate.subtract(1, 'month')
          endDate.endOf('month')
          startDate.subtract(12, 'months')
          startDate.startOf('month')
          break
      }

      endDate = moment(endDate).format('YYYY-MM-DD')
      startDate = moment(startDate).format('YYYY-MM-DD')

      if (reverse) {
        return qs.stringify({
          end_date: startDate,
          start_date: endDate
        })
      }

      return qs.stringify({
        start_date: startDate,
        end_date: endDate
      })
    },
    /**
     * Validates email addresses
     * @param {string} email email address
     * @return {boolean}
     */
    verifyEmail (email) {
      let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(email)
    },
    /**
     * Validate mobile numbers
     * @param {integer} mobile mobile number
     * @return {boolean}
     */
    verifyMobileNumber (mobile) {
      let regex = /^(27|0)[6-8][0-9]{8}$/
      return regex.test(mobile)
    },
    /**
     * Pass the user roles so we can set the default business
     * @param {array} roles Users roles per business
     * @returns {void}
     */
    setDefaultBusiness (roles) {
      // for now assume the first role in the array is the default one
      localStorage.setItem('org_id', roles[0]['org_id'])
      localStorage.setItem('org_name', roles[0]['org_name'])
      localStorage.setItem('org_logo', roles[0]['org_logo'])
      localStorage.setItem('org_slug', roles[0]['org_slug'])
      localStorage.setItem('org_industry_id', roles[0]['org_industry_id'])
      localStorage.setItem('can_invite', JSON.stringify(roles[0]['role_slug'] === 'business-admin'))
      localStorage.setItem('industry_icon', '/static/' + roles[0]['industry_icon'])
      localStorage.setItem('org_join_date', roles[0]['org_join_date'])
      localStorage.setItem('role', roles[0]['role'])
      localStorage.setItem('org_reviews', JSON.stringify(roles[0]['org_reviews']))
    },
    /**
     * Determines whether to pluralize words based on conditions
     * @param {string} entity filters|reviews|billing
     * @returns {string}
     */
    toPluralize (entity) {
      switch (entity) {
        case 'reviews':
          return this.total_records > 1 ? 'reviews' : 'review'
        case 'filters':
          return this.no_of_selected_filters > 1 ? 'filters' : 'filter'
        case 'invoice':
          return this.total_records > 1 ? 'invoices' : 'invoice'
        case 'invoices':
        case 'eft-matching':
          return this.total_records > 1 ? 'results' : 'result'
      }
    },
    /**
     * Refreshes section of view after a response from the api (used in pagination cases)
     * @param {object} data data from api
     * @param {string} entity reviews|billing
     * @returns {void}
     */
    refresh ({data}, entity = '') {
      this.dataSet = data
      this.total_records = data.total
      this.items = data.data
      if ('all_records' in this) {
        if ('allRecordsCount' in data) {
          this.all_records = data.allRecordsCount
        } else {
          this.all_records = -1
        }
      }
      if ('all_records' in this) {
        if ('allRecordsStartDate' in data) {
          this.reviews_start_date = data.allRecordsStartDate
        } else {
          this.reviews_start_date = ''
        }
      }

      if (entity) {
        switch (entity) {
          case 'reviews':
            this.refreshReviews()
            break
          case 'eft-matching':
            this.refreshEntity('eft-matching')
            break
          case 'invoices':
            this.refreshEntity('invoices')
            break
        }
      }
    },
    /**
     * Shows textual display to match search filters or term used
     * @return {void}
     */
    refreshReviews () {
      if (this.keyword_search && this.total_records === 0) {
        this.search_message = `<strong>0 results</strong>`
      } else if (this.keyword_search && this.no_of_selected_filters === 0) {
        this.search_message = `<strong>${this.reviewThreshold()} ${this.toPluralize('reviews')} </strong> with keyword "${this.keyword_string}"`
      } else if (this.keyword_search && this.no_of_selected_filters > 0) {
        this.search_message = `<strong>${this.reviewThreshold()} ${this.toPluralize('reviews')} </strong> with ${this.no_of_selected_filters} ${this.toPluralize('filters')} and keyword "${this.keyword_string}"`
      } else {
        this.search_message = `<strong>${this.total_records} ${this.toPluralize('reviews')}</strong>`
      }
    },
    refreshEntity (entity) {
      this.search_message = `<p class="has-text-grey is-size-7 margin-bottom-12">${this.total_records} ${this.toPluralize(entity)}</p>`
    },
    /**
     * Tests if path is for tab.
     * @param {string} routeName name path to test
     * @param {string} path path to test
     * @returns {boolean}
     */
    openActiveTabForURL (routeName, path) {
      return routeName === path
    },
    getInvoiceItems (invoice) {
      return JSON.parse(invoice.invoice_items)
    },
    /**
     * Get description out of invoice object
     * @param {String} invoice Invoice object as string
     * @param {string} forUserType admin/portal
     * @returns {string}
     */
    getDescription (invoice, forUserType = 'portal') {
      let invoiceItems = this.getInvoiceItems(invoice)
      const keys = Object.keys(invoiceItems) // Sometimes the keys are listed as 0 and 2 instead of 0 and 1 - rather get last key

      let obj
      if (invoice.created_for === 'SUBSCRIPTION') {
        const lastKey = keys[keys.length - 1]
        obj = invoiceItems[lastKey]
      } else {
        const firstKey = keys[0]
        obj = invoiceItems[firstKey]
      }

      let desc = ''
      if (obj !== undefined) {
        desc = obj.name

        if (forUserType === 'admin') {
          if (desc === 'Reviews') {
            desc += ` - ${obj.qty}`
          } else if (desc === 'Lite Subscription Package (Monthly Payment)') {
            desc = `Lite - Monthly`
          } else if (desc === 'Lite Subscription Package (Annual Payment)') {
            desc = `Lite - Annual`
          } else if (desc === 'Pro Subscription Package (Annual Payment)') {
            desc = `Pro`
          } else if (desc === 'Enterprise Subscription Package (Annual Payment)') {
            desc = `Enterprise`
          } else if (desc === 'Pro Rated Lite (Monthly)') {
            desc = `Lite - Monthly - Pro Rata`
          }
        }
      }

      return desc
    },
    getPrice (invoice) {
      let invoiceItems = this.getInvoiceItems(invoice)
      let totalPrice = 0.00
      invoiceItems.forEach(lineItem => {
        let cost = parseFloat(lineItem.price)
        totalPrice += cost * lineItem.qty
      })

      return Math.round(totalPrice * 100) / 100
    },
    getFormattedPrice (invoice) {
      let formatter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }
      let invoiceItems = this.getInvoiceItems(invoice)
      let totalPrice = 0.00
      invoiceItems.forEach(lineItem => {
        let cost = parseFloat(lineItem.price)
        totalPrice += cost * lineItem.qty
      })
      return formatter(totalPrice)
    },
    formatPrice (val) {
      let converter = (number) => {
        number = number.toFixed(2) + ''
        let x = number.split('.')
        let x1 = x[0]
        let x2 = x.length > 1 ? '.' + x[1] : ''
        let rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }
      return converter(val)
    },
    getIncidentReference (incidentRefNumber, incidentIdNumber, incidentAccountNumber) {
      let retVal = 'Not provided'

      if (typeof incidentRefNumber !== 'undefined' && incidentRefNumber !== null && incidentRefNumber.length > 0) {
        retVal = incidentRefNumber
      } else if (typeof incidentIdNumber !== 'undefined' && incidentIdNumber !== null && incidentIdNumber.length > 0) {
        retVal = incidentIdNumber
      } else if (typeof incidentAccountNumber !== 'undefined' && incidentAccountNumber !== null && incidentAccountNumber.length > 0) {
        retVal = incidentAccountNumber
      }

      return retVal
    },
    showHideReviewInfo () {
      this.showInfo = !this.showInfo
    },
    showHideReviewAuthor () {
      this.showAuthor = !this.showAuthor
    },
    privateReply (reply) {
      return reply === 2
    },
    showHideReviewNotes () {
      this.showNotes = !this.showNotes
    },
    isMultipleOfTwo (index) {
      return index % 2 === 0
    },
    asText (data, wordLimit, dots = '(...)') {
      if (typeof data !== 'undefined' && data !== null && data.length > 0) {
        let finalText = ''
        let text2 = data.replace(/\s+/g, ' ')
        let text3 = text2.split('')
        let numberOfWords = text3.length
        let i = 0
        if (numberOfWords > wordLimit) {
          for (i = 0; i < wordLimit; i++) {
            finalText = finalText + '' + text3[i] + ''
          }
          return finalText + ' ' + dots
        } else return data
      }
      return ''
    },

    /**
     * Check whether to disable submit form button
     * @param {Boolean} formSubmitted If submitted the form
     * @param {Object} origValObj Original value of fields
     * @param {Object} actualValObj Current value of fields
     * @returns {boolean}
     */
    canDisableSubmitBtn (formSubmitted, origValObj, actualValObj) {
      if (formSubmitted) {
        return true
      }

      let isModified = false
      for (let key in origValObj) {
        let origVal = origValObj[key]
        let val = actualValObj[key]
        if (origVal === null) {
          origVal = ''
        }
        if (val === null) {
          val = ''
        }

        if (origVal !== val) {
          isModified = true
          break
        }
      }
      return !isModified
    },
    /*
     * return nps category
     *
     * @param rating
     * @return string
    */
    category (rating) {
      if (rating >= 0 && rating < 7) {
        return 'Detractor'
      } else if (rating > 6 && rating < 9) {
        return 'Passive'
      } else if (rating > 8 && rating <= 10) {
        return 'Promotor'
      }
    },
    /*
     * return nps class according to rating
     *
     * @return string
     * @param  rating
    */
    getNPSClass (rating) {
      if (rating >= 0 && rating < 7) {
        return 'nps-red'
      } else if (rating > 6 && rating < 9) {
        return 'nps-orange'
      } else if (rating > 8 && rating <= 10) {
        return 'nps-green'
      }
    },
    /*
     * return user full name
     *
     * @return string
     * @param user
     */
    getFullName (user) {
      return `${user.first_name}` + ' ' + `${user.last_name}`
    },
    /*
    * update filter list
    *
    * @param action
    * @return {void}
    */
    updateFilterList (action = null) {
      const subscriptionDetails = localStorage.getItem('billingDetails') ? JSON.parse(localStorage.getItem('billingDetails')) : ''
      if (subscriptionDetails && subscriptionDetails.subscription.name === 'Free') {
        if (action && action === 'trustindex') {
          this.filterList = [
            {
              name: 'Previous month',
              value: 'previous_month'
            }
          ]
        } else {
          this.filterList = [
            {
              name: 'Last 7 days',
              value: '7_days'
            },
            {
              name: 'Previous month',
              value: 'previous_month'
            }
          ]
        }
      }
    },
    /**
     * Recache website page
     *
     * @param {string} url Page URL to recache
     * @returns {void}
     */
    recache (url = '') {
      url = process.env.HP_APP_URL + url
      axios.post('https://api.prerender.io/recache', {
        prerenderToken: process.env.PRERENDER_TOKEN,
        url: url
      })
    },
    /**
     * Recache review detail page
     *
     * @param {array} reviewData Array of object having business slug and review permalink
     * @returns {void}
     */
    recacheReviewDetail (reviewData) {
      for (let review of reviewData) {
        this.recache(`/${review.bizSlug}/reviews/${review.permalink}`) // Review detail page
      }
    },
    /**
     * Recache CF home page
     *
     * @returns {void}
     */
    recacheHomepage () {
      this.recache() // Home page
    },
    /**
     * Recache website pages related to business
     *
     * @param {array} bizSlugs Business slugs
     * @param {array} industries Industries slug
     * @returns {void}
     */
    recacheOnBizModified (bizSlugs, industries = []) {
      this.recacheHomepage()

      for (let bizSlug of bizSlugs) {
        this.recache(`/${bizSlug}`) // Business detail page
      }

      for (let industry of industries) {
        this.recache(`/industries/${industry}`) // Industry details page
      }
    },
    /**
     * Recache website page related to review on review touched(delete, republish, edit)
     *
     * @param {array} industries Industries slug
     * @param {array} bizSlugs Business slugs
     * @param {array} reviewData Array of object having business slug and review permalink
     * @returns {void}
     */
    recacheOnReviewTouched (industries = [this.business.industry.slug], bizSlugs = [this.businessSlug], reviewData = [{
      bizSlug: this.businessSlug,
      permalink: this.reviewPermalink
    }]) {
      this.recacheOnBizModified(bizSlugs, industries)

      this.recacheReviewDetail(reviewData) // Review detail page
    },
    /**
     * Show 'Posted on' log text
     * @param {String} datetime Datetime of log
     * @returns {String}
     */
    showPostedLog (datetime) {
      return `Posted on ${this.$options.filters.prettyDateTime(datetime)}`
    },

    /**
     * Show 'Updated on' log text
     * @param {Object} entity Review/message
     * @returns {String}
     */
    showUpdatedLog (entity) {
      if (entity.revision) {
        return `<br> Last updated by ${entity.revision.user.first_name} ${entity.revision.user.last_name} on ${this.$options.filters.prettyDateTime(entity.revision.created_at)}`
      }
      return ''
    },

    /**
     * Show 'Updated By' log text
     * @param {Object} entity Review/message
     * @returns {String}
     */
    showUpdateLog (entity) {
      if (entity.latest_revision.length > 0) {
        let log
        let that = this
        entity.latest_revision.forEach(function (v, i) {
          if (v.data.type === 'updated') {
            log = `<br> Last updated by ${v.user.first_name} ${v.user.last_name} on ${that.$options.filters.prettyDateTime(v.created_at)}`
          }
        })
        return log
      }
      return ''
    },

    /**
     * Show 'Deleted by' log text
     * @param {Object} entity Review/message
     * @returns {String}
     */
    showDeleteLog (entity) {
      if (entity.latest_revision.length > 0) {
        let log
        let that = this
        entity.latest_revision.forEach(function (v, i) {
          if (v.data.type === 'deleted') {
            log = `<br> Deleted by ${v.user.first_name} ${v.user.last_name} on ${that.$options.filters.prettyDateTime(v.created_at)}`
          }
        })
        return log
      }
      return ''
    },

    /**
     * Open modal to edit the review
     * @param {Object} reviewData Review text
     * @param {Object} reviewMeta Review metadata
     * @returns {void}
     */
    openReviewEditModal (reviewData, reviewMeta) {
      if (reviewData.content.charAt(0) !== '<') {
        reviewData.content = `<div>${reviewData.content}</div>`
      }

      reviewMeta.title = reviewData.title
      reviewMeta.content = reviewData.content
      reviewMeta.rating = reviewData.rating

      // initialize modal's props
      this.modal_props = {
        'title': 'Edit review',
        'btn_action_title': 'SAVE CHANGES',
        'show_btns': true,
        'task': 'editReview',
        'reviewEditorData': reviewData,
        'reviewMeta': reviewMeta,
        setWidthAuto: true
      }
      // fire off confirmation modal
      modal(this.modal_props)
    },

    /**
     * Open modal to edit the review
     * @param {String} review Review text
     * @param {Object} reviewMeta Review metadata
     * @returns {void}
     */
    openReviewReplyEditModal (review, reviewMeta) {
      if (review.charAt(0) !== '<') {
        review = `<div>${review}</div>`
      }
      if (reviewMeta.content.charAt(0) !== '<') {
        reviewMeta.content = `<div>${reviewMeta.content}</div>`
      }

      // initialize modal's props
      this.modal_props = {
        'title': 'Edit review',
        'btn_action_title': 'SAVE CHANGES',
        'show_btns': true,
        'task': 'editReviewReply',
        'reviewMeta': reviewMeta,
        'editor': {
          'content': review
        }
      }
      // fire off confirmation modal
      modal(this.modal_props)
    },

    /**
     * Open delete confirmation modal
     * @param {Integer} messageId Review text
     * @returns {void}
     */
    openDeleteReplyModal (messageId) {
      // initialize modal's props
      this.modal_props = {
        'title': 'Delete business reply',
        'small_title': 'Are you sure you want to delete this business reply ? This cannot be undone.',
        'btn_action_title': 'YES',
        'show_btns': true,
        'task': 'deleteBusinessReply',
        'messageId': messageId
      }
      // fire off confirmation modal
      modal(this.modal_props)
    },

    /**
     * Send request to Edit review
     * @param {Object} props Review data from modal
     * @returns {void}
     */
    editReview (props) {
      if (
        props.reviewMeta.content !== props.reviewEditorData.content ||
        props.reviewMeta.title !== props.reviewEditorData.title ||
        props.reviewMeta.rating !== props.reviewEditorData.rating ||
        props.reviewMeta.npsRating !== props.reviewEditorData.npsRating ||
        props.reviewMeta.response_time !== props.reviewEditorData.response_time
      ) {
        let url
        if (props.reviewMeta.type === 'review') {
          url = `/admin/${this.businessSlug}/reviews/${props.reviewMeta.id}`
        } else {
          url = `/admin/${this.businessSlug}/reviews/${this.getReviewPermalink}/reply/${props.reviewMeta.id}`
        }
        let responseTime = null
        if (props.reviewEditorData.responseTimestamp) {
          responseTime = `${moment(props.reviewEditorData.responseTimestamp).format('YYYY-MM-DD')} ${props.reviewEditorData.hours || '00'}:${props.reviewEditorData.min || '00'}:00`
        }
        axios.put(url, {
          content: props.reviewEditorData.content,
          title: props.reviewEditorData.title,
          rating: props.reviewEditorData.rating,
          npsRating: props.reviewEditorData.npsRating,
          response_time: responseTime
        })
          .then((response) => {
            this.fetch()

            const msg = 'Review successfully updated.'
            flash(msg)
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Successfully edited review',
                'displayedMessage': msg
              }
            })

            if (props.reviewMeta.type === 'review') {
              this.recacheOnReviewTouched([])
            } else {
              this.recacheReviewDetail([{bizSlug: this.businessSlug, permalink: this.reviewPermalink}])
            }
          })
          .catch(() => {
            const msg = 'Unable to update review. Please try again later.'
            flash(msg, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to edit review',
                'displayedMessage': msg
              }
            })
          })
      }
    },
    /**
     * Send request to Edit review reply
     * @param {Object} props Review Reply data from modal
     * @returns {void}
     */
    editReviewReply (props) {
      if (props.reviewMeta.content !== props.editor.content || (typeof props.reviewMeta.replyType !== 'undefined')) {
        let url = `/admin/${this.businessSlug}/reviews/${this.getReviewPermalink}/reply/${props.reviewMeta.id}`
        axios.put(url, {
          content: props.editor.content,
          replyType: typeof props.reviewMeta.replyType !== 'undefined' ? props.reviewMeta.replyType : null
        })
          .then((response) => {
            this.fetch()
            const msg = 'Review reply successfully updated.'
            flash(msg)
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Successfully edited review reply',
                'displayedMessage': msg
              }
            })

            if (props.reviewMeta.type === 'review') {
              this.recacheOnReviewTouched([])
            } else {
              this.recacheReviewDetail([{bizSlug: this.businessSlug, permalink: this.reviewPermalink}])
            }
          })
          .catch(() => {
            const msg = 'Unable to update review. Please try again later.'
            flash(msg, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to edit review',
                'displayedMessage': msg
              }
            })
          })
      }
    },
    /**
     * Get bisuness logo
     * @param {Object} business business model
     * @returns {string}
     */
    getBusinessIcon (business) {
      if (business.org_logo) {
        return business.org_logo
      }
      if (typeof business !== 'undefined' && typeof business.industry !== 'undefined') {
        return `/static/assets/img/industries/icons/${business.industry.slug}-icon.jpg`
      }
      const localIndustryIcon = localStorage.getItem('industry_icon')
      if (typeof localIndustryIcon !== 'undefined' && localIndustryIcon.length > 0) {
        return localIndustryIcon
      }
    },
    getCurrentBusinessActiveSubscription () {
      const slug = this.slug
      axios.get(`/subscriptions/${slug}/get-current-active-subscription`)
        .then(({data}) => {
          if (typeof data.subscriptionType !== 'undefined' && typeof data.subscriptionType.name !== 'undefined') {
            this.isFreeSubscriptionActive = data.subscriptionType.name.toLowerCase() === 'free'
          }
        })
    },
    displaySuccessMsg (msg, gtmName) {
      flash(msg, 'is-success')
      dataLayer.push({
        'userMessage': {
          'messageType': 'success',
          'messageName': gtmName,
          'displayedMessage': msg
        }
      })
    },
    displayErrMsg (response, gtmName, defaultMsg = '') {
      let msg = ''
      if ('error' in response.response.data) {
        msg = response.response.data.error
      } else if (response.response.status === 401) {
        msg = 'You are not authorized to perform this action'
      } else if (response.response.status === 422) {
        msg = []
        for (let field in response.response.data) {
          msg.push(response.response.data[field][0])
        }
      } else if (defaultMsg) {
        msg = defaultMsg
      }

      flash(msg, 'is-danger')

      dataLayer.push({
        'userMessage': {
          'messageType': 'error',
          'messageName': gtmName,
          'displayedMessage': msg
        }
      })
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
        $event.preventDefault()
      }
    },
    /**
     * Return sorted array according to the parameters passed into this function
     *
     * @param {array} result is the array that needs to be sorted
     * @param {string} columnName is the name of database field
     * @param {string} sortOrder is the order that has two values (asc/desc)
     * @returns {Array}
     */
    orderBy (result, columnName, sortOrder) {
      let finalResult = result.map((res) => {
        if (typeof (res[columnName]) === 'string') {
          res['proxyCol'] = res[columnName].toLowerCase()
          columnName = 'proxyCol'
        }
        return res
      })
      return _.orderBy(finalResult, [columnName], [sortOrder])
    },
    /**
     * Get label for date dropdown
     *
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @returns {string}
     */
    customLabel (startDate, endDate) {
      let customLabel = ''
      let dateDiff = moment(endDate).diff(moment(startDate), 'days')

      switch (true) {
        case (dateDiff <= 6):
          customLabel = 'last_7_days'
          break
        case (dateDiff > 7 && dateDiff <= 31):
          customLabel = 'previous_month'
          break
        case (dateDiff > 31 && dateDiff <= 183):
          customLabel = 'last_6_months'
          break
        case (dateDiff > 183):
          customLabel = 'last_12_months'
          break
      }
      return customLabel
    },
    purchaseCreditsAndOrInvites (addOnCredits, addOnInvites = 0) {
      const paymentPlan = typeof this.userInfo.payment_plan !== 'undefined' ? this.userInfo.payment_plan.payment_method : 'EFT'
      const payload = {
        business_id: this.businessId,
        payment_method: paymentPlan,
        review_count: parseInt(addOnCredits),
        invite_count: parseInt(addOnInvites)
      }
      axios.post(`/subscriptions/purchase-reviews`, payload)
        .then(({data}) => {
          this.$router.push(`/billing/checkout/${data.invoice.id}`)
        })
        .catch((error) => {
          console.log('error', error.response.data)
        })
    },
    /**
     * Purchase digits fro review Credits/Review Invites etc
     * @param {Number} addOnCredits
     * @param {Number} addOnInvites
     * @returns {void}
     */
    purchaseDigits ({addOnCredits = 0, addOnInvites = 0}) {
      let paymentPlan = typeof this.userInfo.payment_plan !== 'undefined' ? this.userInfo.payment_plan.payment_method : 'EFT'
      const payload = {
        business_id: this.businessId,
        payment_method: paymentPlan,
        review_count: parseInt(addOnCredits),
        invite_count: parseInt(addOnInvites)
      }
      axios.post(`/subscriptions/purchase-reviews`, payload)
      .then(({data}) => {
        this.$router.push(`/billing/checkout/${data.invoice.id}`)
      })
      .catch((error) => {
        console.log('error', error.response.data)
      })
    },
    /**
     * Displays notification message globally
     * @param {string} message message to display
     * @param {string} css properties to use
     * @param {boolean} hideCloseBtn flag to hide close btn
     * @param {integer} duration flag to set duration for display
     * @returns {null}
     */
    showFlash (message, css = 'is-success', hideCloseBtn, duration) {
      this.$toasted.show(`${message}`, {
        className: `${css}`,
        containerClass: 'toast-container',
        icon: this.getIcon(css),
        theme: 'outline',
        singleton: true,
        duration: duration || 2500,
        iconPack: 'fontawesome',
        position: 'top-right',
        fullWidth: false,
        keepOnHover: true
      })
    },
    /**
     * Get the icon class to render on the left of the Notification
     * @param {string} css The default CSS class passed to the notification i.e is-success, is-warning or is-danger
     * @return {string}
     */
    getIcon (css) {
      switch (css) {
        case 'is-warning':
          return 'fa-exclamation-triangle'
        case 'is-info':
          return 'fa-info-circle'
        case 'is-danger':
          return 'fa-ban'
        default:
          return 'fa-check'
      }
    },
    /**
     * Generates dynamic ratings for search filter on selected rating to show on dropdown as a selection
     * @param {string} rating rating value from dropdown selection
     * @returns {string}
     */
    generateDynamicRatings (rating) {
      let ratingHTML = ''
      let rate = parseInt(rating)
      let colour = ''
      for (let init = 1; init <= 5; init++) {
        if (rate === 5) {
          colour = 'green'
          ratingHTML += '<span class="' + colour + '"><i class="fas fa-star" aria-hidden="true"></i></span>'
        } else if (init === 1 && rate === 1) {
          colour = 'red'
          ratingHTML += '<span class="' + colour + '"><i class="fas fa-star" aria-hidden="true"></i></span>'
        } else if (rate > 1 && init <= rate) {
          if (rate === 4) {
            colour = 'light-green'
          }
          if (rate === 3) {
            colour = 'yellow'
          }
          if (rate === 2) {
            colour = 'orange'
          }
          ratingHTML += '<span class="' + colour + '"><i class="fas fa-star" aria-hidden="true"></i></span>'
        }
      }
      let greyfill = (5 - rate)
      for (let init = 0; init < greyfill; init++) {
        ratingHTML += '<span class="grey"><i class="fas fa-star" aria-hidden="true"></i></span>'
      }
      return ratingHTML
    },
    /**
     * Copy the text given to clipboard
     * @param {string} text
     * @param {string} message
     * @param {string} msgType
     * @returns void
     */
    copyGivenText ({text, message = `Text copied to clipboard`, msgType = 'is-success'}) {
      this.$copyText(text)
      .then(() => {
        flash(message, msgType)
      })
    }
  },
  computed: {
    /*
     * Check whether blue block is active or not
     *
     * returns {bool}
     */
    isBlueBlockActive () {
      return this.$route.query.hasOwnProperty('isVisible') && this.$route.query.isVisible === 'true'
    },

    /**
     * fetch and return the billing details from the local storage
     *
     * @returns {object}
     */
    localBillingDetails () {
      return localStorage.getItem('billingDetails') ? JSON.parse(localStorage.getItem('billingDetails')) : {
        subscription: {
          name: ''
        }
      }
    },
    isDesktop () {
      return this.screenWidth > 991
    },
    isTablet () {
      return this.screenWidth >= 768 && this.screenWidth <= 991
    },
    isMobile () {
      return this.screenWidth < 768
    },
    /**
     * Checking if a user is a paid user
     * @return {boolean}
     */
    isPaidUser () {
      return this.userInfo.subscription.name !== 'Free'
    },
    isFreeSubscription () {
      return this.userInfo.subscription.name === 'Free' && this.userInfo.subscription.subscriptionTypeId === 1
    },
    isGrowthSubscription () {
      return this.growthCategory.indexOf(this.userInfo.subscription.name) !== -1
    },
    isProSubscription () {
      return this.proCategory.indexOf(this.userInfo.subscription.name) !== -1
    },
    isAnnualSubscription () {
      return this.userInfo.subscription.cycle === 'annum'
    },
    canPurchaseReviewsAndInvites () {
      return this.userInfo.subscription.canPurchaseReviewsAndInvites
    },
    reviewCreditUnitPrice () {
      return parseFloat(this.userInfo.subscription.reviewCreditPrice)
    },
    subscUpgradeUrl () {
      return `/billing/edit-plan/${this.userInfo.subscription.name.toLowerCase()}/${this.userInfo.subscription.cycle}`
    }
  },
  filters: {
    prettyDateTime (date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    capitalize: function (value) {
      if (!value) {
        return value
      }

      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/misc.js